// Dependencies
import Vue                         from 'vue'
import Router                      from 'vue-router'
import { i18n, loadLanguageAsync } from '../lang/lang'

// Route Views
import Promotion        from '../views/promotion/Promotion'
import { AES, HmacMD5 } from '../lib/crypto/crypto'

Vue.use(Router)

const routes = [
  {
    path     : '/:lang',
    props    : true,
    component: {
      render (c) {
        return c('router-view')
      }
    },
    children : [
      {
        name     : 'Promotion',
        path     : '/',
        component: Promotion,
        meta     : {}
      },
    ]
  },

  {
    name    : 'Default',
    path    : '*',
    redirect: '/' + i18n.locale,
  },
]

const createRouter = () => new Router({
  mode  : 'history',
  base  : process.env.BASE_URL,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const router = createRouter()

router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  const langExists = i18n.languages.find(l => l.locale === lang) ? true : false

  if (langExists) {
    loadLanguageAsync(lang)
      .then(() => next())
      .catch(() => next({ replace: true, name: to.matched.length > 0 ? to.name : 'Default', params: { lang: i18n.locale } }))
  } else {
    next({ replace: true, name: to.matched.length > 0 ? to.name : 'Default', params: { lang: i18n.locale } })
  }
})

router.afterEach((to, from, next) => {
  Vue.config.lang = to.params.lang
  if (to.name !== 'Promotion') {
    Vue.$sessionStorage.set(HmacMD5.hash('ROUTE'), AES.encrypt({
      name    : to.name,
      fullPath: to.fullPath,
      hash    : to.hash,
      meta    : to.meta,
      params  : to.params,
      path    : to.path,
      query   : to.query
    }))
  }
})

const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Router.prototype.replace = function replace (location) {
  return routerReplace.call(this, location).catch(error => error)
}

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  window.isVueRoutesInited = false
}

export default router
